import { render } from "./App.vue?vue&type=template&id=582fb5e0&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=582fb5e0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=582fb5e0&lang=scss&scoped=true"

import exportComponent from "/builds/optelgroup/exploration/reusable-components/supply-chain-simulator/prototype/iscp-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582fb5e0"]])

export default __exports__